export default "__VITE_ASSET__C2ZSWtZg__"